import $api from "../api/axios";

export interface UpdateCustomSnippetsUrlRequest {
  customSnippetsUrl: string | null;
}

export interface UpdateCustomSnippetsUrlResponse {
  status: number;
  data: {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    organizationId: number;
    role: string;
    featurePermissionLevel: number;
    hasAdminPanelAccess: boolean;
    customSnippetsUrl: string | null;
  };
}

export async function updateCustomSnippetsUrl(
  request: UpdateCustomSnippetsUrlRequest
): Promise<UpdateCustomSnippetsUrlResponse> {
  const response = await $api.patch("/auth/custom-snippets-url", request);
  return response.data;
}